import React from "react";
import { Link } from "react-router-dom";
import {
  constants,
  DateFormat,
} from "../../../Containers/Constants/commenFeatures";

const VideoBanner = ({ video }) => {
  const isMp4 = video?.url?.endsWith(".mp4");

  // Function to add autoplay=0 to YouTube URLs
  const getVideoUrl = (url) => {
    if (!url) return "";
    
    // Check if URL already has parameters
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}autoplay=0&rel=0`;
  };

  return (
    <div className="tradingAlgoInto">
      <div className="videoBox">
        <div>
          {isMp4 ? (
            <video
              width="100%"
              height="100%"
              controls
              controlsList="nodownload"
            >
              <source src={video?.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <iframe
              width="100%"
              height="100%"
              src={getVideoUrl(video?.url)}
              title="Video player"
              frameBorder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
      </div>

      <div className="tradingAlgoInto-text">
        <Link to={`videos/${video?.resourceId}`}>
          <h2>{video?.name}</h2>
        </Link>
        <p className="date">
          {video ? DateFormat(video.date, constants.resourceDateFormat) : ""}
        </p>
      </div>
    </div>
  );
};

export default VideoBanner;